import { Box } from '@mui/material';
import { WsCard, CardVariant } from 'wisestep-base';

import NoDashboardIcon from '../../../images/NoDashboards.svg';
export const NoDashboards = () => (
  <Box width="100%">
    <WsCard
      title="No Dashboards created or shared to you"
      middleComponent={<img src={NoDashboardIcon} alt="NoDashboards" />}
      isButton={false}
      cardType={CardVariant.WITH_OUT_BG}
      sx={{ textAlign: 'center', m: '5vw' }}
    />
  </Box>
);

export default NoDashboards;
